var el;

function onProfileCoverEditModeChange(e) {
    el.classList.toggle('__edit-mode', e.detail.editMode);
}

function activate(_el) {
    el = _el;
    el.addEventListener('profileCoverEditModeChange', onProfileCoverEditModeChange);
}

function deactivate() {
    el.removeEventListener('profileCoverEditModeChange', onProfileCoverEditModeChange);
    el = null;
}

export default { activate, deactivate };

export { activate, deactivate };
